<div class="search-dialog">

  <!-- Header -->
  <div class="dialog-header">
    <div class="header-left">
      <span class="pi pi-search header-icon"></span>
      <h2>Search Results</h2>
      <span class="result-count">{{ results.length }} result{{ results.length !== 1 ? 's' : '' }}</span>
    </div>
    <button pButton icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" (click)="close()" class="close-btn" aria-label="Close"></button>
  </div>

  <!-- Cross-project hint -->
  @if (resultMessage) {
    <div class="other-projects-banner">
      <span class="pi pi-info-circle"></span>
      <span>{{ resultMessage }} Switch project to view those results.</span>
    </div>
  }

  <!-- No results -->
  @if (results.length === 0) {
    <div class="empty-state">
      <span class="pi pi-search empty-icon"></span>
      <p>No tags found in this project.</p>
    </div>
  }

  <!-- Results table -->
  @if (results.length > 0) {
    <app-checksheet-assignments-table
      [assignments]="assignmentData"
      [displayColumns]="displayColumns"
      (navigate)="onAssignmentNavigation($event)"
    ></app-checksheet-assignments-table>
  }

  <!-- Footer -->
  <div class="dialog-footer">
    <button pButton label="Close" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="close()"></button>
  </div>

</div>
